import { render, staticRenderFns } from "./UploadStockRequest.vue?vue&type=template&id=391010fc"
import script from "./UploadStockRequest.vue?vue&type=script&lang=js"
export * from "./UploadStockRequest.vue?vue&type=script&lang=js"
import style0 from "./UploadStockRequest.vue?vue&type=style&index=0&id=391010fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports